import React, { type FC } from 'react'
import { useIntl } from 'react-intl'

import { paginationState } from 'Pages/RecipientsList/recoil/state/results'
import {
  Flex,
  Spinner,
  TEXT_VARIANT_STANDARD,
  TITLE_VARIANT_L,
  Text,
  Title,
} from 'mailup-web-components'
import { useRecoilValue } from 'recoil'

const RecipientsCounter: FC = () => {
  const intl = useIntl()

  const { totalItems, loading } = useRecoilValue(paginationState)

  return (
    <Flex alignItems="center" gap="8px">
      <Title variant={TITLE_VARIANT_L}>
        <strong>{intl.formatNumber(totalItems)}</strong>
      </Title>
      {loading && (
        <Text variant={TEXT_VARIANT_STANDARD}>
          <Spinner />
        </Text>
      )}
    </Flex>
  )
}

export default RecipientsCounter
